import Api from '@/services/api';
import {removeEmptyParams} from '@utils';

export default {
  rentalTags() {
    return Api()
      .get('/rentaltags', {})
      .then((res) => {
        res.data.forEach((e) => {
          this.formatRes(e);
        });
        return res.data;
      });
  },
  create(rentaltag) {
    return Api()
      .post('/rentaltag', rentaltag)
      .then((res) => this.formatRes(res.data));
  },
  update(rentaltag) {
    return Api()
      .put('/rentaltag/' + rentaltag.id, rentaltag)
      .then((res) => this.formatRes(res.data));
  },
  formatRes(e) {
    return e;
  },
};
